<template>
  <span class="relative inline-block mt:10">
    <input
        type="checkbox"
        class="checkbox opacity-0 absolute"
        id="chk"
        @change="changeMode"
        :checked="isDarkMode"
    >
    <label
        class="label bg-slate-900 dark:bg-white shadow dark:shadow-gray-800 cursor-pointer rounded-full flex justify-between items-center p-1 w-14 h-8"
        for="chk"
    >
      <i class="uil uil-moon text-[20px] text-yellow-500"></i>
      <i class="uil uil-sun text-[20px] text-yellow-500"></i>
      <span class="ball bg-white dark:bg-slate-900 rounded-full absolute top-[2px] left-[2px] size-7"></span>
    </label>
  </span>
</template>


<script>
import feather from 'feather-icons';

export default {
  data() {
    return {
      htmlTag: document.getElementsByTagName('html')[0],
      isDarkMode: false,
    };
  },
  mounted() {
    feather.replace();
    this.loadMode();
  },
  methods: {
    changeMode() {
      if (this.htmlTag.className.includes('dark')) {
        this.htmlTag.className = 'light';
        this.isDarkMode = false;
        localStorage.setItem('mode', 'light');
      } else {
        this.htmlTag.className = 'dark';
        this.isDarkMode = true;
        localStorage.setItem('mode', 'dark');
      }
    },
    loadMode() {
      const savedMode = localStorage.getItem('mode') || 'light';
      this.htmlTag.className = savedMode;
      this.isDarkMode = savedMode === 'dark';
    },
  },
};
</script>


<style lang="scss" scoped>
.checkbox {
  display: none;
}

.label {
  width: 2.6rem !important;
  height: 1.4rem !important;

  .uil {
    font-size: 16px !important;
  }
}

.ball {
  transition: transform 0.2s linear;
  top: 1px !important;
  left: 1px !important;
  width: 1.25rem !important;
  height: 1.25rem !important;
}

.checkbox:checked + .label .ball {
  transform: translateX(calc(100% - 1px)) !important;
}
</style>
